import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';
import { useClickOutside } from '@/hooks/useClickOutside';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useClickOutside<HTMLDivElement>(() => setOpen(false));

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <label className="mb-2 block text-sm font-medium text-foreground-700">
        {t('hero_dropdown_label')}
      </label>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-left text-sm text-foreground-700 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <span className="text-foreground-600">{t('hero_dropdown_placeholder')}</span>
        <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true"></i>
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-20 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-2">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-3 py-2 text-sm text-foreground-700 hover:bg-primary-50 cursor-pointer"
            >
              <span className="flex h-10 w-10 flex-none items-center justify-center overflow-hidden rounded-md bg-background-100">
                <img src={cat.image} alt="" aria-hidden="true" className="h-full w-full object-cover object-top" />
              </span>
              <span className="flex-1">{t(`category_${cat.key}`)}</span>
              <i className="ri-arrow-right-up-line text-primary-500" aria-hidden="true"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}